/**
 * Display-preference constants shared by the custom-datasource table and the three
 * surfaces that own its paging (the dashboard widget, the CDS detail page and the
 * CDS edit/preview page).
 */

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 200];

/**
 * Page size used until the user picks one.
 *
 * MUST be one of `PAGE_SIZE_OPTIONS` — otherwise the Page size radio group opens
 * with nothing selected while the table is already paging at this size, so the
 * control doesn't reflect reality and the current size can't be re-selected.
 * `tablePreferences.spec.ts` pins that invariant.
 *
 * 25 matches the shared entity-table default (`useGetDefaultTablePreferences`),
 * which keeps CDS consistent with every other table in the product. This is a
 * deliberate change from the previous hardcoded 20: a CDS table with no stored
 * preference now shows 25 rows per page instead of 20.
 */
export const DEFAULT_PAGE_SIZE = 25;
